import { STATUS } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, className }) {
  const s = STATUS[status] || STATUS.neu;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
        s.color,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} />
      {s.label}
    </span>
  );
}
